import './DatePicker.scss'

import React, {RefObject, useEffect, useRef} from 'react'
import {fromDisplayDate, toDisplayDate} from '../../util/dates'

import {DOMAttrs} from '@codeurs/front'
import {FormField} from '../layout/Form'
import Pikaday from 'pikaday'
import {style} from '../../util/style'
import {useFormContext} from 'react-hook-form'

const styles = style('datepicker')

export const DatePicker: React.FC<DOMAttrs> = ({
	label,
	error,
	name,
	placeholder,
	onChange = null,
	hideIcon = false,
	toFormat = 'dd/MM/yyyy',
	...attrs
}) => {
	const {setValue, watch} = useFormContext()
	const dateRef: RefObject<HTMLInputElement> = useRef()
	useEffect(() => {
		const picker = new Pikaday({
			field: dateRef.current,
			onSelect: (date: Date) => {
				return setValue(name, toDisplayDate(date, toFormat))
			},
			format: toFormat,
			toString: toDisplayDate,
			parse: fromDisplayDate
		})
		return () => picker.destroy()
	}, [])
	const element = useRef<HTMLDivElement>()
	const inputValue = watch(name)

	return (
		<div className={styles} ref={element}>
			<div className={styles('container')} ref={dateRef}>
				<FormField
					amount={null}
					name={name}
					id={name}
					placeholder={placeholder}
					value={inputValue}
					autoComplete="off"
				/>
			</div>
		</div>
	)
}
